import React, { InputHTMLAttributes, TextareaHTMLAttributes } from 'react';

interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: React.ReactNode;
  error?: string;
  textarea?: boolean;
}

const FormInput = ({
  label,
  error,
  textarea,
  className = '',
  ...props
}: FormInputProps) => {
  const inputClasses = `
    w-full px-4 py-2 border rounded-lg text-green-700 placeholder-green-300
    focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-200
    ${error ? 'border-red-500' : 'border-green-300'}
    ${className}
  `;

  return (
    <div className="mb-4">
      <label className="block text-gray-700 text-sm font-medium mb-2">
        {label}
      </label>
      {textarea ? (
        <textarea
          className={`${inputClasses} min-h-[120px]`}
          {...(props as unknown as TextareaHTMLAttributes<HTMLTextAreaElement>)}
        />
      ) : (
        <input
          className={inputClasses}
          {...props}
        />
      )}
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

export default FormInput;